module.exports = __webpack_public_path__ + "static/media/route-interstate.02a87041.svg";